export enum FileConversionStatus {
    Processing = "Processing",
    Converted = "Converted",
    PartiallyConverted = "PartiallyConverted",
    Failed = "Failed",
}